import { Globe, Zap, RefreshCw } from "lucide-react";

const plans = [
    {
        title: "Reach a wider audience",
        description: "More visitors to your website means more sales. Expand your brand awareness online to get more traffic.",
        icon: Globe
    },
    {
        title: "Value for money & efficient",
        description: "Don't waste your money on expensive monthly ads, our tools will boost the basic organic keywords through SEO.",
        icon: Zap
    },
    {
        title: "Upsell your customers",
        description: "Promotions and newsletters will keep your customers up to date and keeping coming back to your website for repeat business.",
        icon: RefreshCw
    }
];

export default function WhyMarket() {
    return (
        <section className="py-12 md:py-20 px-4 sm:px-6 lg:px-8">
            <div className="container">
                <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
                    Why market your business online
                </h2>
                <p className="text-center text-gray-300 max-w-2xl mx-auto mb-16 text-lg">
                    Unlock the full potential of your business with powerful digital marketing strategies
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    {plans.map((plan, index) => {
                        const Icon = plan.icon;

                        return (
                            <div
                                key={index}
                                className="group bg-gray-800/30 backdrop-blur-sm rounded-2xl p-8 border border-gray-700/50 hover:border-blue-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/10 hover:-translate-y-1"
                            >
                                {/* Icon Box with gradient */}
                                <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-blue-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                                    <Icon size={28} className="text-white" />
                                </div>

                                {/* Content */}
                                <h3 className="text-white text-xl font-bold mb-3 group-hover:text-blue-400 transition-colors">
                                    {plan.title}
                                </h3>
                                <p className="text-gray-300 text-base leading-relaxed">
                                    {plan.description}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}